import { atom, useAtomValue } from "jotai";
import { atomFamily } from "jotai/utils";

import {
	$lastQueryKeyForPage,
	$queryState,
	type RequestPageStatus,
	deriveRequestPageStatus,
	emptyRequestPageStatus,
	pageKey as makePageKey,
} from "../../internal/request-page";

export type { RequestPageStatus };

const $requestPageStatus = atomFamily((pageKey: string) =>
	atom((get): RequestPageStatus => {
		const lastKey = get($lastQueryKeyForPage(pageKey));
		if (!lastKey) {
			return emptyRequestPageStatus;
		}

		const state = get($queryState(lastKey));
		return deriveRequestPageStatus(state);
	})
);

/**
 * Lightweight hook to get the current execution status of a request page.
 * Looks up the last query key used for this page, then reads its state.
 * Used for displaying status badges in the navigation pane.
 */
export const useRequestPageStatus = (documentId: string, pageId: string): RequestPageStatus => {
	return useAtomValue($requestPageStatus(makePageKey(documentId, pageId)));
};
